import React, { Fragment } from 'react';
import Footer from '../../components/footer';
import PageTitle from '../../components/pagetitle';
import PreviousProgramSection from '../../components/PreviousProgramSection';
import Scrollbar from '../../components/scrollbar';

const PreviousProgramPage = () => {
  return (
    <Fragment>
      <PageTitle pageTitle={'Previous Event'} pagesub={'Previous Event'} />

      <PreviousProgramSection pbClass={'pb-0'} />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default PreviousProgramPage;
